module.exports = __webpack_public_path__ + "static/media/works4.d20b007c.png";